import { useRef } from "react";
import { motion, useScroll, useTransform, useReducedMotion } from "framer-motion";
import { Reveal } from "./Reveal";
import { IMAGES, CENTERS } from "../../data";

export const GlobalPresence = () => {
  const ref = useRef(null);
  const reduce = useReducedMotion();
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const imgY = useTransform(scrollYProgress, [0, 1], [reduce ? "0%" : "-8%", reduce ? "0%" : "8%"]);

  return (
    <section id="global" data-testid="global" ref={ref} className="relative py-28 lg:py-40 border-t border-hairline overflow-hidden">
      <motion.div style={{ y: imgY }} className="absolute inset-0 z-0">
        <img src={IMAGES.global} alt="" className="h-full w-full object-cover opacity-15" />
        <div className="absolute inset-0 bg-ink/70" />
      </motion.div>

      <div className="relative z-10 mx-auto max-w-[1500px] px-6 lg:px-12">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          <div>
            <Reveal>
              <span className="font-mono text-xs tracking-[0.3em] uppercase text-gold">Global Presence</span>
              <h2 className="font-serif font-light text-5xl sm:text-6xl lg:text-7xl tracking-tighter text-parchment mt-6 text-balance">
                Capital knows<br />no <span className="italic text-gold">borders.</span>
              </h2>
              <p className="text-stone leading-relaxed mt-6 max-w-md">
                Our network spans the world's principal financial centres — connecting exceptional companies with the private capital best suited to their ambition.
              </p>
            </Reveal>

            <div className="mt-12 grid grid-cols-2 sm:grid-cols-4 gap-y-6 gap-x-4">
              {CENTERS.map((c, i) => (
                <Reveal key={c} delay={i * 0.05}>
                  <div className="flex items-center gap-2">
                    <span className="h-1.5 w-1.5 rounded-full bg-gold animate-pulse" />
                    <span className="font-mono text-xs tracking-[0.15em] uppercase text-stone">{c}</span>
                  </div>
                </Reveal>
              ))}
            </div>
          </div>

          <Reveal delay={0.2} className="relative flex items-center justify-center min-h-[420px]">
            <div className="relative w-[340px] h-[340px] sm:w-[420px] sm:h-[420px]">
              <div className="absolute inset-0 rounded-full border border-hairline animate-spin-slow" />
              <div className="absolute inset-[12%] rounded-full border border-hairline animate-spin-rev" />
              <div className="absolute inset-[26%] rounded-full border border-gold/30 animate-spin-slow" />
              <div className="absolute inset-[40%] rounded-full border border-gold/50" />
              <div className="absolute inset-[40%] rounded-full bg-gold/5 backdrop-blur-sm flex items-center justify-center">
                <span className="font-serif italic text-gold text-2xl sm:text-3xl">Worldwide</span>
              </div>
              {CENTERS.map((c, i) => {
                const angle = (i / CENTERS.length) * Math.PI * 2;
                const r = 50;
                const x = 50 + Math.cos(angle) * r;
                const y = 50 + Math.sin(angle) * r;
                return (
                  <span key={c} className="absolute h-2 w-2 rounded-full bg-gold shadow-[0_0_12px_#C2A366]"
                    style={{ left: `${x}%`, top: `${y}%`, transform: "translate(-50%,-50%)" }} />
                );
              })}
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
};
